import { useIsOwner, useSessionPermission } from '@btime/react-session'

import { useNavigationWithModalCloser } from '../../contexts/NavigationContext'
import {
  useOpenChangePasswordModal,
  useOpenCreateTemplateRecordModal,
  useOpenEditUserModal,
  useOpenEditUsersModal,
  useOpenUserModal
} from '../../routes/modals/modalsActions'
import { useRemoveContracts } from './_requests/removeContract'
import { useRecoverDeletedContract } from './_requests/recoverDeletedContract'

export const useUserDetailAction = item => {
  const openDetailsModal = useOpenUserModal()
  return { click: () => openDetailsModal(item) }
}

export const useUserLogsAction = item => {
  const isOwner = useIsOwner()
  const navigate = useNavigationWithModalCloser()

  return {
    click: () => navigate(`/logs?entityUserIds=${item.id}`),
    link: `/logs?entityUserIds=${item?.id}`,
    hasPermission: isOwner
  }
}

export const useUserEditAction = item => {
  const openEditModal = useOpenEditUserModal()
  const canEdit = useSessionPermission('editUser')

  return {
    click: () => openEditModal({ id: item.id }),
    hasPermission: canEdit
  }
}

export const useUserChangePasswordAction = item => {
  const openModal = useOpenChangePasswordModal()
  const canEdit = useSessionPermission('changePassword')

  return {
    click: () => openModal(item.id),
    hasPermission: canEdit
  }
}

export const useUserTempleteRecordAction = item => {
  const openCreateTemplateRecordModal = useOpenCreateTemplateRecordModal()
  const canCreateTemplateRecord = useSessionPermission('createTemplateRecord')

  return {
    click: () => openCreateTemplateRecordModal({ entity: 'user', recordId: item.id }),
    hasPermission: canCreateTemplateRecord
  }
}

export const useUserRemoveAction = item => {
  const canDelete = useSessionPermission('deleteUser')
  const [deleteItems, { loading }] = useRemoveContracts()

  return {
    click: () => deleteItems([item.id]),
    hasPermission: canDelete
  }
}

export const useUserNewServiceOrderActions = ids => {
  // TODO: Fix for using ids instead of selectedUsers
  // const ids = selectedUsers?.map(prop('id'))
  // const canCreateSO = useSessionPermission('createServiceOrder')
  // const openEditServiceOrdersModal = useOpenEditServiceOrdersModal()
  // return {
  // hasPermission: canCreateSO && ids?.length <= 30,
  // click: () => {
  // const initialState = [
  // ...(selectedUsers?.map(({ id, name, __typename }) => ({ userOrGroup: { id, name, __typename } })) ?? [])
  // ]
  // return openEditServiceOrdersModal({ initialState })
  // }
  // }
}

export const useUsersLogsAction = ids => {
  const isOwner = useIsOwner()
  const navigate = useNavigationWithModalCloser()

  return {
    click: () => navigate(`/logs?entityUserIds=${ids?.join(',')}`),
    link: `/logs?entityUserIds=${ids?.join(',')}`,
    hasPermission: isOwner
  }
}

export const useUsersEditAction = ids => {
  const openBulkEditModal = useOpenEditUsersModal()
  const canEdit = useSessionPermission('editUser')

  return {
    click: () => openBulkEditModal(ids),
    hasPermission: canEdit && ids?.length <= 20
  }
}

export const useUsersRemoveAction = ids => {
  const canDelete = useSessionPermission('deleteUser')
  const [deleteItems, { loading }] = useRemoveContracts()

  return {
    click: () => deleteItems(ids),
    hasPermission: canDelete
  }
}

export const useRecoverDeletedUser = item => {
  const [recover] = useRecoverDeletedContract()
  return {
    click: () => recover(item),
    hasPermission: true
  }
}
